import classNames from "classnames";
import * as React from "react";
import { ComponentType, FC } from "react";
import { SelectTriggerProps } from "~/sharedComponents/select";
import { icon, Icon } from "../icons";
import { LabeledItem } from "../list";
import * as styles from "./UserRole.less";

type UserRoleProps = {
    roleEditor: ComponentType;
    roleName: string;
    withDetails: boolean;
};

export const UserRole: FC<UserRoleProps> = props => {
    const { roleName, roleEditor: RoleEditor, withDetails } = props;

    if (RoleEditor) {
        return <RoleEditor />;
    }

    if (withDetails && roleName) {
        return <RoleText roleName={roleName} />;
    }

    return null;
};

const RoleText: FC<{ roleName: string }> = props => {
    const { roleName } = props;
    return (
        <span title={roleName} className={styles.role} data-testid="role_text">
            {roleName}
        </span>
    );
};

type Props = SelectTriggerProps<LabeledItem> & { isOpened: boolean };
export const RoleSelectTrigger: FC<Props> = props => {
    const { value, isDisabled, isOpened } = props;

    if (isDisabled) {
        return (
            <div className={styles.role_viewer}>
                <RoleText roleName={value?.label} />
            </div>
        );
    }

    return (
        <div title={value?.label} className={styles.role_editor} role="combobox">
            <div className={styles.inner}>
                <div className={classNames(styles.hover_effect, isOpened && styles.opened)} />
                <RoleText roleName={value?.label} />
                <Icon iconName={icon.chevron_down_small} />
            </div>
        </div>
    );
};
